"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPropertyItemFileUploadPiclib = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../../models");
var FileUpload_1 = require("../../FileUpload");
var ConfirmPropertyItem_1 = require("../ConfirmPropertyItem");
var Wrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 16px 0 0;\n"], ["\n  padding: 16px 0 0;\n"])));
var ThumbnailBox = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 36px;\n"], ["\n  margin-bottom: 36px;\n"])));
var WithThumbnail = function (_a) {
    var thumbnail = _a.thumbnail;
    var type = thumbnail.type, url = thumbnail.url, name = thumbnail.name;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(ThumbnailBox, null,
            react_1.default.createElement(FileUpload_1.Thumbnail, { type: type, url: url, loading: false })),
        react_1.default.createElement("div", null, name)));
};
var ConfirmPropertyItemFileUploadPiclib = function (_a) {
    var thumbnail = _a.thumbnail, className = _a.className, color = _a.color, propertyId = _a.propertyId;
    return (react_1.default.createElement(ConfirmPropertyItem_1.ConfirmPropertyItem, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.fileUpload, inputFormatType: models_1.FILE_UPLOAD_PROPERTY_INPUT_TYPE.piclib, className: className, color: color }, thumbnail != null ? react_1.default.createElement(WithThumbnail, { thumbnail: thumbnail }) : ''));
};
exports.ConfirmPropertyItemFileUploadPiclib = ConfirmPropertyItemFileUploadPiclib;
var templateObject_1, templateObject_2;
